import React from 'react';
import Navigation from '../components/Navigation';
import ContactForm from '../components/ContactForm';
import Logo from '../components/Logo';
import Footer from '../components/Footer';
const Contact = () => {
    return (
        <div>
            <Logo/>
            <Navigation />
            <ContactForm />
            <Footer />
        </div>
    );
};

export default Contact;